/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import './NavBar.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons'
import {useRecoilState, useSetRecoilState, useRecoilValue} from 'recoil';
import {
  currentSceneIDState, currentScreenState, displayNavigationState,
  sceneHistoryQueueState,
} from '../recoil/atoms';
import {
  PLAYLIST_SCREEN,
  SELECTION_SCREEN,
} from '../recoil/state';
import {currentGameInfoQuery, currentSceneInfoQuery} from '../recoil/selectors';

function NavBar() {
  const setCurrentScreen = useSetRecoilState(currentScreenState);
  const setCurrentSceneID = useSetRecoilState(currentSceneIDState);
  const [sceneHistoryQueue, setSceneHistoryQueue] = useRecoilState(sceneHistoryQueueState);
  const currentScene = useRecoilValue(currentSceneInfoQuery);
  const currentGame = useRecoilValue(currentGameInfoQuery);
  const showNavigation = useRecoilValue(displayNavigationState);

  const goBackward = (e) => {
    if(sceneHistoryQueue.length > 0) {
      const [sceneID, ...queue] = sceneHistoryQueue;
      setSceneHistoryQueue(queue);
      setCurrentSceneID(sceneID);
    } else {
      setSceneHistoryQueue([]);
      setCurrentSceneID(null);
      setCurrentScreen(PLAYLIST_SCREEN);
    }
  };

  const exit = (e) => {
    setCurrentSceneID(null);
    setCurrentScreen(PLAYLIST_SCREEN);
  };

  const goForward = (e) => {
    const nextScene = currentScene.choices[0].linkToScene || '';
    const firstScene = currentGame.tree.id || '';

    if(currentScene.choices.length > 1) {
      setCurrentScreen(SELECTION_SCREEN);
    } else  if (nextScene === firstScene) {
      setCurrentSceneID(null);
      setCurrentScreen(PLAYLIST_SCREEN);
    } else {
      setCurrentSceneID(nextScene);
    }
  };

  return (
      <div className={`player-nav d-flex align-items-center justify-content-between w-100 py-4 px-2 ${ showNavigation ? '' : 'mouse--still'}`}>
        <button className="link-button player-nav__link fa-2x" onClick={goBackward}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <button className="link-button player-nav__link fa-2x" onClick={exit}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <button className="link-button player-nav__link fa-2x" onClick={goForward}>
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>
  );
}

export default NavBar;
